import React, { useState } from 'react';
import { addDoc, collection } from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';
import ApiInstructionsModal from './ApiInstructionsModal';

function EssayList({ essays, onSelectEssay, selectedEssayId }) {
  const [showApiModal, setShowApiModal] = useState(false);
  
  const handleCreateEssay = async () => {
    try {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const newEssay = {
        title: 'Untitled Essay',
        body: '',
        status: 'draft',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        uid: currentUser.uid
      };

      const docRef = await addDoc(collection(db, "essays"), newEssay);
      onSelectEssay({ id: docRef.id, ...newEssay });
    } catch (error) {
      console.error("Error creating essay:", error);
    }
  };

  const currentUser = auth.currentUser;
  const apiEndpoints = currentUser ? {
    listEndpoint: `/api/essays?userId=${currentUser.uid}`,
    singleEndpoint: `/api/essay?userId=${currentUser.uid}&essayId=ESSAY_ID`,
  } : null;

  return (
    <div className="flex-none w-[320px] border-r border-gray-200 bg-white flex flex-col">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <button
          onClick={handleCreateEssay}
          className="py-1 text-black font-bold text-left"
        >
          + New Essay
        </button>
        <button
          onClick={() => setShowApiModal(true)}
          className="text-gray-500 hover:text-gray-700"
          title="API Instructions"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto">
        {essays.map(essay => (
          <div
            key={essay.id}
            onClick={() => onSelectEssay(essay)}
            className={`p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 ${
              selectedEssayId === essay.id ? 'bg-gray-50' : ''
            }`}
          >
            <h3 className="font-medium">{essay.title}</h3>
            <p className="text-sm text-gray-500">
              {essay.status === 'published' ? 'Published' : 'Draft'}
            </p>
          </div>
        ))}
      </div>

      <ApiInstructionsModal
        isOpen={showApiModal}
        onClose={() => setShowApiModal(false)}
        userId={currentUser?.uid}
        apiEndpoints={apiEndpoints}
      />
    </div>
  );
}

export default EssayList; 